import { inject, Injectable } from '@angular/core';
import { doc, getDoc, collection, addDoc, query, where, getDocs, Firestore, setDoc, updateDoc, docData } from '@angular/fire/firestore';
import { fetchSignInMethodsForEmail, signOut, User } from 'firebase/auth';
// import { addDoc, query, where } from 'firebase/firestore';
import { Auth, signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, authState } from '@angular/fire/auth';
import { map, Observable, of, switchMap } from 'rxjs';
import { Router } from '@angular/router';
import { getAnalytics, logEvent } from '@angular/fire/analytics';
import { FirebaseApp } from '@angular/fire/app';
import { environment } from '../../environments/environment';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user$: Observable<User | null>;
  app = inject(FirebaseApp);    // get the already-created app
  analytics = getAnalytics(this.app);

  // Temperory admin login
  // email:admin@chalkbacket.com
  // password:12345678

  constructor(private router: Router, private auth: Auth, private firestore: Firestore) {
    this.user$ = authState(this.auth);
  }

  isAdmin() {
    return this.user$.pipe(
      switchMap(user => {
        if (!user) return of(false);

        const ref = doc(this.firestore, `users/${user.uid}`);
        return docData(ref).pipe(
          map((data: any) => data?.role === 'admin')
        );
      })
    );
  }
  async logout() {
    try {
      await signOut(this.auth);
      console.log("User logged out");
      this.router.navigate(['/'])
    } catch (error) {
      console.error("Logout error:", error);
    }
  }
  // Get current user
  getCurrentUser() {
    return this.auth?.currentUser;
  }

  login(email: string, password: string) {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  // async checkDuplicateEmail(email: string) {
  //   // const rootId = await this.getOrCreateRootId();
  //   // registration/${rootId}/
  //   const studentsCol = collection(this.firestore, `students`);
  //   const q = query(studentsCol, where('email', '==', email));
  //   const snapshot = await getDocs(q);
  //   return !snapshot.empty; // true if duplicate exists
  // }

  // async registerStudent(data: any) {
  //   const studentCol = collection(this.firestore, 'students');

  //   const docRef = await addDoc(studentCol, {
  //     ...data,
  //     createdAt: new Date(),
  //     isVerified: false,
  //   });

  //   // 👉 This is the actual document ID
  //   const documentId = docRef.id;
  //   const mailCol = collection(this.firestore, `mail`);

  //   await addDoc(mailCol, {
  //     to: data.email,
  //     message: {
  //       subject: "Verify Your Email Address",
  //       html: `
  //           <h1>Welcome, ${data.name}!</h1>
  //           <p>Please verify your email address to complete your registration.</p>
  //           <a href="https://${environment.firebaseConfig.projectId}.web.app/verify-email/${documentId}">
  //               Verify Email Now
  //           </a>
  //           <p>If the link above doesn't work, copy and paste the following URL into your browser:</p>
  //           <p>https://${environment.firebaseConfig.projectId}.web.app/verify-email/${documentId}</p>
  //       `,
  //     },
  //   });
  // }

  async verifyStudent(id: string) {
    const studentRef = doc(this.firestore, `students/${id}`);
    const snapshot = await getDoc(studentRef);

    if (snapshot.exists()) {
      const studentData = snapshot.data();

      // Update field
      await updateDoc(studentRef, { isVerified: true });
      logEvent(this.analytics, 'student_verified', {
        name: studentData['name']
      })
      return {
        success: true,
        message: "Student verified successfully",
      };
    } else {
      return {
        success: false,
        message: "Student not found",
      };
    }
  }

  async registerStudent(data: any) {
    try {
      // 🔐 Create password using name + passing year
      const password = `${data.name}${data.passingYear}`;

      // ✅ Create user in Firebase Auth
      const userCredential = await createUserWithEmailAndPassword(
        this.auth,
        data.email,
        password
      );

      const user = userCredential.user;

      // ✅ Send default Firebase verification email
      await sendEmailVerification(user);

      // ✅ Store extra student data in Firestore
      const studentRef = doc(this.firestore, `students/${user.uid}`);

      await setDoc(studentRef, {
        name: data.name,
        email: data.email,
        passingYear: data.passingYear,
        collegeName: data.collegeName,
        degreeandBranch: data.degreeandBranch,
        phoneNumber: data.phoneNumber,
        universityName: data.universityName,
        isVerified: false,
        createdAt: new Date()
      });
      // await sendEmailVerification(user);
      return {
        success: true,
        message: "To complete your registration, click on the link shared on your registered email id."
      };

    } catch (error: any) {

      // 🔥 Handle Email Already Exists Error
      if (error.code === 'auth/email-already-in-use') {
        return {
          success: false,
          message: "Email already exists."// Please login instead."
        };
      }

      return {
        success: false,
        message: error.message
      };
    }
  }
  async checkDuplicateEmail(email: string) {
    try {
      const methods = await fetchSignInMethodsForEmail(this.auth, email);

      if (methods.length > 0) {
        return true; // Email exists
      }

      return false;

    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async checkVerificationStatus() {
    try {
      const user = this.auth.currentUser;

      if (!user) {
        console.log("No user registered");
        return false;
      }

      await user.reload();

      console.log("Email Verified Status:", user.emailVerified);

      if (!user.emailVerified) {
        return false;
      }

      const studentRef = doc(this.firestore, `students/${user.uid}`);

      await setDoc(studentRef, {
        isVerified: true,
        verifiedAt: new Date()
      }, { merge: true });

      console.log("Firestore Updated: isVerified = true");

      return true;

    } catch (error) {
      console.error("Verification check error:", error);
      return false;
    }
  }
  async getAllRegisteredStudents() {
    // const rootId = await this.getOrCreateRootId();
    // registration/${rootId}/
    const studentsCol = collection(this.firestore, `students`);
    const studentSnapshot = await getDocs(studentsCol);
    const studentsList = studentSnapshot.docs.map(doc => {
      const data = doc.data();
      const dateObject = (data['createdAt'] as any).toDate();
      data['createdAt'] = dateObject;
      return {
        ...data
      };
    });

    return studentsList;
  }

}
